import {computed, Injectable, Signal, signal, WritableSignal} from '@angular/core';
import {tooltipDefaultConfig} from './tooltipDefaultConfig';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {

// Base delay for the first hover (ms)
  public baseDelay: WritableSignal<number | undefined> = signal(tooltipDefaultConfig.delay);

  // Delay while user is actively flicking through items (ms)
  public warmDelay: WritableSignal<number> = signal(50);


  public warmTTL: WritableSignal<number> = signal(1000);

  private warm: WritableSignal<boolean>  = signal(false);
  private timer: any;

  public currentDelay: Signal<number | undefined> = computed(() => (this.warm() ? this.warmDelay() : this.baseDelay()));

  /** Call this when a hover starts to enter/refresh warm mode. */
  public bumpWarm(ttl?: number) {
    clearTimeout(this.timer);
    this.warm.set(true);
    this.timer = setTimeout(() => this.warm.set(false), ttl ?? this.warmTTL());
  }

  /** Optional: force-enable/disable warm mode globally (e.g., a toggle). */
  public setWarm(enabled: boolean) {
    clearTimeout(this.timer);
    this.warm.set(enabled);
  }
}
